import { Observable } from 'rxjs/Observable';
import { debug } from 'util';

export interface EventAsset {
  assetId: string;
  height: number;
  mimeType: string;
  width: number;
  size?: number;
}

export interface MessageLike {
  timestamp: number;
}

export interface MessageLikes {
  [personId: string]: MessageLike
}[]

export enum ChannelMessageType {
  image = 'image',
  text = 'text'
}

export interface ChannelMessage {
  type: ChannelMessageType;
  creatorId: string;
  timestamp: number;
  commentCount?: number;
  likeCount?: number;
  likes?: MessageLikes
}

export interface ChannelImageMessage extends ChannelMessage {
  caption?: string;
  asset: EventAsset;
}

export interface ChannelTextMessage extends ChannelMessage {
  caption?: string;
}

export type ChannelMessageId = string;

export interface IChannel {
  observeMessages$(): Observable<{[key: string]: ChannelMessage}>;
}

export class Channel implements IChannel {
  constructor(private eventDataSource: any, private channelId: string) {}
  observeMessages$() {
    return this.eventDataSource.observeChannelMessages$(this.channelId);
  }
}